/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { LoaderCachingPolicy, } from "@fluidframework/driver-definitions/internal";
import { DocumentStorageServiceProxy, PrefetchDocumentStorageService, } from "@fluidframework/driver-utils/internal";
import { ShreddedSummaryDocumentStorageService } from "./shreddedSummaryDocumentStorageService.js";
import { WholeSummaryDocumentStorageService } from "./wholeSummaryDocumentStorageService.js";
export class DocumentStorageService extends DocumentStorageServiceProxy {
    get logTailSha() {
        return this._logTailSha;
    }
    static loadInternalDocumentStorageService(id, manager, logger, policies, driverPolicies, blobCache, snapshotTreeCache, shreddedSummaryTreeCache, noCacheGitManager, getStorageManager) {
        const storageService = driverPolicies?.enableWholeSummaryUpload
            ? new WholeSummaryDocumentStorageService(id, manager, logger, policies, driverPolicies, blobCache, snapshotTreeCache, noCacheGitManager, getStorageManager)
            : new ShreddedSummaryDocumentStorageService(id, manager, logger, policies, driverPolicies, blobCache, shreddedSummaryTreeCache, getStorageManager);
        // TODO: worth prefetching latest summary making version + snapshot call with WholeSummary storage?
        if (!driverPolicies?.enableWholeSummaryUpload &&
            policies.caching === LoaderCachingPolicy.Prefetch) {
            return new PrefetchDocumentStorageService(storageService);
        }
        return storageService;
    }
    constructor(id, manager, logger, policies, driverPolicies, blobCache, snapshotTreeCache, shreddedSummaryTreeCache, noCacheGitManager, getStorageManager) {
        super(DocumentStorageService.loadInternalDocumentStorageService(id, manager, logger, policies, driverPolicies, blobCache, snapshotTreeCache, shreddedSummaryTreeCache, noCacheGitManager, getStorageManager));
        this.id = id;
        this.manager = manager;
        this.noCacheGitManager = noCacheGitManager;
        this._logTailSha = undefined;
    }
    async getSnapshotTree(version) {
        const tree = await this.internalStorageService.getSnapshotTree(version);
        if (tree !== null) {
            this._logTailSha =
                ".logTail" in tree.trees ? tree.trees[".logTail"].blobs.logTail : undefined;
        }
        return tree;
    }
}
//# sourceMappingURL=documentStorageService.js.map